import { Calendar, Tag, MapPin, Link2, Monitor, Layers, Image, Map as MapIcon, MessageSquare, Video, Radio, Users, UserCog, Bell, BarChart3, Settings, Settings2, Palette, AlertTriangle } from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  icon: any;
  badge?: string;
}

export interface NavGroup {
  id: string;
  label: string;
  items: NavItem[];
}

export const adminNavGroups: NavGroup[] = [
  {
    id: 'programming',
    label: 'PROGRAMACION',
    items: [
      { id: 'events', label: 'Eventos', icon: Calendar },
      { id: 'categories', label: 'Categorias', icon: Tag },
      { id: 'locations', label: 'Ubicaciones', icon: MapPin },
      { id: 'connectors', label: 'Conectores', icon: Link2 },
    ]
  },
  {
    id: 'screens',
    label: 'PANTALLAS',
    items: [
      { id: 'signage-overview', label: 'Panel de Control', icon: Monitor },
      { id: 'signage-display', label: 'Display', icon: Settings2 },
      { id: 'signage-slots', label: 'Slots', icon: Layers },
      { id: 'signage-themes', label: 'Temas', icon: Palette },
      { id: 'signage-alerts', label: 'Alertas', icon: AlertTriangle },
      { id: 'media', label: 'Media Library', icon: Image },
      { id: 'map', label: 'Mapa', icon: MapIcon },
      { id: 'social', label: 'Social Wall', icon: MessageSquare },
    ]
  },
  {
    id: 'broadcast',
    label: 'EMISION',
    items: [
      { id: 'streaming', label: 'Streaming', icon: Video },
      { id: 'live', label: 'En Directo', icon: Radio },
    ]
  },
  {
    id: 'team',
    label: 'EQUIPO',
    items: [
      { id: 'users', label: 'Usuarios', icon: Users },
      { id: 'staff', label: 'Staff', icon: UserCog },
      { id: 'notifications', label: 'Notificaciones', icon: Bell },
    ]
  },
  {
    id: 'system',
    label: 'SISTEMA',
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
      { id: 'settings', label: 'Configuracion', icon: Settings },
    ]
  },
];
